/**
 * @generated SignedSource<<06d7ad96b8aa65f1e2559cb206c3859d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateSlackVerificationKeyInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type createSlackVerificationKeyMutation$variables = {
  input: CreateSlackVerificationKeyInput;
};
export type createSlackVerificationKeyMutation$data = {
  readonly createSlackVerificationKey: {
    readonly key: string | null;
  } | null;
};
export type createSlackVerificationKeyMutation = {
  variables: createSlackVerificationKeyMutation$variables;
  response: createSlackVerificationKeyMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateSlackVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createSlackVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createSlackVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createSlackVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "20434b0cd4fa95e4ff8778de156aff70",
    "id": null,
    "metadata": {},
    "name": "createSlackVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createSlackVerificationKeyMutation(\n  $input: CreateSlackVerificationKeyInput!\n) {\n  createSlackVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "39633f78f990bf6f4e5589827b8d27cd";

export default node;
